import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface SectionHeadingProps {
    eyebrow: string
    title: ReactNode
    intro?: ReactNode
    align?: 'left' | 'center'
    tone?: 'dark' | 'light'
    className?: string
}

export const SectionHeading: FC<SectionHeadingProps> = ({
    eyebrow,
    title,
    intro,
    align = 'left',
    tone = 'dark',
    className
}): ReactNode => {
    const light = tone === 'light'

    return (
        <div className={cn('max-w-3xl', align === 'center' && 'mx-auto text-center', className)}>
            <p
                className={cn(
                    'inline-flex items-center gap-2 text-sm font-bold tracking-[0.14em] uppercase',
                    light ? 'text-sun' : 'text-coral-deep'
                )}
            >
                <span aria-hidden='true' className={cn('h-0.5 w-6 rounded-full', light ? 'bg-sun' : 'bg-coral')} />
                {eyebrow}
            </p>

            <h2
                className={cn(
                    'mt-4 font-heading font-soft text-4xl leading-[1.05] font-semibold tracking-[-0.015em] text-balance sm:text-5xl',
                    light ? 'text-paper' : 'text-ink'
                )}
            >
                {title}
            </h2>

            {intro && (
                <p className={cn('mt-5 text-lg leading-relaxed text-pretty', light ? 'text-[#c3cad8]' : 'text-muted-foreground')}>
                    {intro}
                </p>
            )}
        </div>
    )
}
